export { Tabs, type TabsProps, type TabItem } from "./Tabs";
export * from "./useTabsController";
